
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"currentColor","transform":"rotate(134 137.016 137.775)","x":"123.016","y":"102.275","width":"28","height":"71","rx":"14"}}),_c('circle',{attrs:{"stroke":"currentColor","stroke-width":"28","cx":"87","cy":"88","r":"46"}})])])
          )
        }
      }
    